import React from "react"
import { FaCode, FaSketch, FaAndroid } from "react-icons/fa"
const services = [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "Web design and development",
    text: `Do you want to develop your own highly customisable website? You do not have to look anywhere else. Depending on your
    needs, we can create a website that is tailored to your needs with or without code!.`,
  },
  {
    id: 2,
    icon: <FaSketch className="service-icon" />,
    title: "Social media marketing & SEO",
    text: ` Use the power of the social media to grow your business. We can help you to get your brand out there, by suggesting you ways you can put
     out your business via social media and through targeted ad campaigns.`,
  },
  {
    id: 3,
    icon: <FaAndroid className="service-icon" />,
    title: "Content Writing ",
    text: `Whether you’re a small business, SaaS company or entrepreneur, our custom content can catapult your online 
    visibility and give you that boost to attract new leads.`,
  },
]

export default services
